function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from "react";
import { isPresent, randomString } from "../../core/utils";
import './filters.scss';
var FilterDropdown = function FilterDropdown(_ref) {
  var items = _ref.items,
    id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  var elementRef = useRef();
  var buttonRef = useRef();
  useEffect(function () {
    if (isPresent(items) && items.length > 0) {
      var _items$find;
      isPresent(value) ? setActiveItem(((_items$find = items.find(function (_) {
        return _.value === value;
      })) === null || _items$find === void 0 ? void 0 : _items$find.text) || '') : setActiveItem(items[0].text);
    }
  }, []);
  var handleItemChanged = function handleItemChanged(item) {
    setActiveItem(item);
    elementRef.current.classList.toggle('show');
    buttonRef.current.classList.toggle('collapsed');
    buttonRef.current.setAttribute('aria-expanded', 'false');
    if (typeof onChange == 'function') onChange(item);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "filter-dropdown border-thick-grey border-radius-7px mb-3 mb-md-0 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-item border-none"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "accordion-header"
  }, /*#__PURE__*/React.createElement("button", {
    ref: buttonRef,
    className: "accordion-button bg-transparent font-size-14 collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#".concat(id),
    "aria-expanded": "true",
    "aria-controls": id
  }, activeItem)), /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    id: id,
    className: "accordion-collapse collapse",
    "aria-labelledby": "headingOne",
    "data-bs-parent": "#accordionExample"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-body p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-group list-group-flush"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("a", {
      className: "cursor-pointer list-group-item border-none list-group-item-action font-size-14 ".concat(item.disabled ? 'disabled' : ''),
      key: index,
      onClick: function onClick() {
        return handleItemChanged(item.text);
      }
    }, item.text);
  })))))));
};
FilterDropdown.defaultProps = {
  items: [],
  id: randomString(8),
  value: undefined,
  onChange: undefined
};
export default FilterDropdown;